<template>
  <div class="flex-between padding-10 color-bg-fff settings-box">
    <div class="flex-start">
      <slot name="tools"></slot>
    </div>
    <div class="flex-start">
      <div>
        <slot name="actions"></slot>
      </div>
      <div class="flex-start margin-left-10">
        <template v-if="$listeners.onChange">
          <el-tooltip effect="dark" content="刷新" placement="top">
            <div @click="onFresh" class="padding-5 pointer">
              <i class="el-icon-refresh-right"></i>
            </div>
          </el-tooltip>
        </template>

        <template v-for="item in list">
          <component
            @setTableAlign="setTableAlign"
            @setTableBorder="setTableBorder"
            :localColumns="localColumns"
            :is="item.component"
            :key="item.name"
            :item="item"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script >
import { computed } from '@vue/composition-api';
import TableFullScreen from './components/table-full-screen.vue';
import TableColumn from './components/table-column.vue';
import TableSize from './components/table-size.vue';
import TableAlign from './components/table-align.vue';
import TableBorder from './components/table-border.vue';
const __sfc_main = {};
__sfc_main.props = {
  columnsSettings: {
    type: Object,
    default: () => {}
  },
  setTableAlign: {
    type: Function,
    default: () => {}
  },
  setTableBorder: {
    type: Function,
    default: () => {}
  },
  localColumns: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const componentList = {
    TableFullScreen,
    TableColumn,
    TableSize,
    TableAlign,
    TableBorder
  };
  const emits = __ctx.emit;
  const props = __props;
  const list = computed(() => {
    const settings = props.columnsSettings;
    const sList = settings.filter(item => item.show).map(item => ({
      ...item,
      component: componentList[item.name]
    }));
    return sList;
  });
  const onFresh = () => {
    emits('onFresh');
  };
  return {
    list,
    onFresh
  };
};
export default __sfc_main;
</script>
<style scoped lang="scss"></style>
